<template>
	<el-popover placement="top" v-model="visible" trigger="click" @hide="closeRecorder">
		<div class="recorder-popover">
			<audio ref="audio" />
			<el-button type="default" size="mini" icon="fa fa-microphone" :disabled="recording" @click="startRecord">
				{{ $t("chatRecorder.recording") }}</el-button
			>
			<el-button type="danger" size="mini" icon="fa fa-stop-circle" :disabled="!recording" @click="stopRecord"> {{ $t("chatRecorder.stop") }}</el-button>
			<el-button type="default" size="mini" icon="fa fa-play" :disabled="duration == 0" @click="playRecord"> {{ duration }}"</el-button>
			<el-button type="primary" size="mini" icon="el-icon-message" :disabled="duration == 0" @click="sendRecord">{{ $t("chatRecorder.send") }}</el-button>
		</div>
		<el-button slot="reference" type="default" size="mini" icon="fa fa-microphone" />
	</el-popover>
</template>

<script>
import Recorderx, { RECORDER_STATE, ENCODE_TYPE } from "recorderx";

import axios from "axios";

export default {
	name: "ChatRecorder",

	props: [],

	mounted() {
		this.rc = new Recorderx({
			sampleRate: 8000,
			sampleBits: 16,
			bufferSize: 4096,
		});
	},

	data() {
		return {
			rc: null,

			recording: false,

			duration: 0,

			maximum: 60,

			overtimeTimer: null,

			visible: false,
		};
	},

	methods: {
		// 开始录音
		async startRecord() {
			this.stopRecord();

			if (!this.$refs.audio.paused) {
				this.$refs.audio.pause();
			}

			try {
				this.setOvertimeTimer();

				this.recording = true;

				await this.rc.start();
			} catch (error) {
				this.clearOvertimeTimer();

				this.recording = false;

				if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
					this.$message({
						message: this.$t("chatRecorder.microphonePermissionDenied"),
						type: "warning",
					});
				} else {
					this.$message({
						message: this.$t("chatRecorder.recordingFailed"),
						type: "warning",
					});
				}
			}
		},

		// 停止录音
		stopRecord() {
			if (this.rc && this.rc.state === RECORDER_STATE.RECORDING) {
				this.rc.pause();

				this.$refs.audio.src = URL.createObjectURL(
					this.rc.getRecord({
						encodeTo: ENCODE_TYPE.WAV,
						compressible: true,
					})
				);

				this.$refs.audio.oncanplay = () => {
					if (this.$refs.audio.duration === Infinity || this.$refs.audio.duration < 1) {
						this.duration = 0;
						this.$message({
							message: this.$t("chatRecorder.timeShort"),
							type: "warning",
						});
					} else {
						this.duration = Number.parseInt(this.$refs.audio.duration);
					}
				};

				this.rc.clear();

				this.clearOvertimeTimer();

				this.recording = false;
			}
		},

		// 播放录音
		playRecord() {
			if (this.duration > 0) {
				this.$refs.audio.play();
			}
		},

		// 关闭录音
		closeRecorder() {
			if (this.rc) {
				this.rc.pause();
				this.rc.clear();
			}

			if (!this.$refs.audio.paused) {
				this.$refs.audio.pause();
			}

			this.recording = false;

			this.duration = 0;

			this.clearOvertimeTimer();
		},

		// 发送语音
		sendRecord() {
			axios({
				method: "get",
				baseURL: this.$refs.audio.src,
				responseType: "blob",
			}).then((response) => {
				const blod = new Blob([response.data], { type: "audio/wav" });
				this.$emit("done", {
					file: blod,
					duration: this.duration,
				});
				this.visible = false;
			});
		},

		// 设置超时定时器
		setOvertimeTimer() {
			this.overtimeTimer = setTimeout(() => {
				this.stopRecord();
				this.$message({
					message: this.$t("chatRecorder.timeLong"),
					type: "warning",
				});
			}, this.maximum * 1000 + 1000);
		},

		// 清空超时定时器
		clearOvertimeTimer() {
			clearTimeout(this.overtimeTimer);
		},
	},
};
</script>

<style lang="less" scoped></style>
